module.exports = __webpack_public_path__ + "static/media/squared.6f353f9c.jpg";